import { request as sendRequest } from '../utils';
import {
    MAIL_SETUP,
    SHOW_MAILER,
    UPDATE_MAILER,
    MAIL_SENDER,
    SEND_TEST_MAIL,
    UNDO_MAILER_CONTENT,
    POST_PRE_LAUNCH,
    CANCEL_SCHEDULED_MAILER,
    TARGET_RECIPIENTS,
    RECIPIENT_HISTORY,
    RECIPIENT_SENT_EMAIL
} from '../routes/api'

const getContractId = () => {
    return(sessionStorage.getItem('contract_id'))
} 

// Keep authoring actions bounded without changing timeouts across Mimir.
const request = (options, ...callbacks) => sendRequest({ timeout: 30000, ...options }, ...callbacks);

class companyMailerApi {
    // options override request defaults for one call, e.g. the recipients export raises the 30 s timeout.
    static search_recipients(id, data, options) {
        return request({ ...options, url: SHOW_MAILER(getContractId(), id) + '/recipients/search', method: 'post', data });
    }

    // apply: false checks the list; apply: true stores its eligible employees; an empty apply clears the stored list.
    static target_recipients(id, { emails, apply }) {
        return request({ url: TARGET_RECIPIENTS(getContractId(), id), method: 'post', data: { emails, apply } });
    }

    static recipient_history(id, customerId) {
        return request({ url: RECIPIENT_HISTORY(getContractId(), id, customerId), method: 'get' });
    }

    // The exact published revision one employee was sent: { content_mailer_id, revision } from their row.
    static sent_email(id, customerId, params) {
        return request({ url: RECIPIENT_SENT_EMAIL(getContractId(), id, customerId), method: 'get', params });
    }

    static builder_mailers(options = {}) {
        return request({ url: MAIL_SETUP(getContractId()), method: 'get', params: { view: 'builder', ...options } });
    }

    static editor_catalog({ key, audience, version, benefit_type, eligibility_mode = 'benefit_eligible' } = {}) {
        const params = { version, benefit_type, eligibility_mode };
        // axios appends [] to array values itself.
        Object.entries(audience || {}).forEach(([name, value]) => { params['audience[' + name + ']'] = value; });
        return request({ url: MAIL_SETUP(getContractId()) + '/editor_catalog' + (key ? '/' + key : ''), method: 'get', params });
    }

    static import_mailer(file) {
        const form = new FormData(); form.append('file', file);
        return request({ url: MAIL_SETUP(getContractId()) + '/import', method: 'post', data: form, timeout: 30000 });
    }

    static create_mailer(data) {
        return request({ url: MAIL_SETUP(getContractId()), method: 'post', data: { company_mailer: data } });
    }

    // Discard an unsent Welcome follow-up.
    static discard_mailer(id) {
        return request({ url: SHOW_MAILER(getContractId(), id), method: 'delete' });
    }

    static activate_mailer(id, revision) {
        return request({ url: SHOW_MAILER(getContractId(), id) + '/activate', method: 'post', data: { expected_revision: revision } });
    }

    static preview_mailer(id, data) {
        return request({ url: SHOW_MAILER(getContractId(), id) + '/preview', method: 'post', data });
    }

    static test_mail(options, onSuccess, onError) {
        return request({ url: SEND_TEST_MAIL(getContractId(), options.id), method: 'post', ...options }, onSuccess, onError);
    }

    static update_mailer(options, onSuccess, onError) {
        return request({ url: UPDATE_MAILER(getContractId(), options.id), method: 'patch', ...options }, onSuccess, onError);
    }

    static show_mailer(options, onSuccess, onError) {
        return request({ url: SHOW_MAILER(getContractId(), options.id), method: 'get', ...options }, onSuccess, onError);
    }

    static mailer_sender(options, onSuccess, onError) {
        return request({url: MAIL_SENDER(getContractId(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

    static revert_to_original(options, onSuccess, onError) {
        return request({url: UNDO_MAILER_CONTENT(getContractId(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

    static post_pre_launch(options, onSuccess, onError) {
        return request({url: POST_PRE_LAUNCH(getContractId(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

    static cancel_schedule_mailer(options, onSuccess, onError) {
        return request({url: CANCEL_SCHEDULED_MAILER(getContractId(), options.id), method: 'get', ...options}, onSuccess, onError)
    }

}

export default companyMailerApi;
